import Vue from 'vue'
import I18n from '../core'
import { version } from 'vue-i18n/package.json'

Vue.$app = Vue.$app || {}

Vue.$app.i18n = I18n
Vue.$app.i18n.version = version
Vue.$app.i18n.showRouteLanguage = process.env.VUE_APP_USE_LANG_IN_URL === 'true'
